export const telephone = '01 46 75 93 60';
